import { render, staticRenderFns } from "./Leaders.vue?vue&type=template&id=af4b00e2"
import script from "./Leaders.vue?vue&type=script&lang=js"
export * from "./Leaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports